import { SITE_DOCUMENT_DETAIL_QUERY_KEY, SITE_DOCUMENT_INVITES_QUERY_KEY, } from '../site_document_details/site_document_details.types';
import { SITE_DOCUMENTS_QUERY_KEY } from '../site_documents/site_documents_view.types';
export const PARTICIPANT_DOCUMENTS_QUERY_KEY = 'participantDocuments';
export const PARTICIPANT_DOCUMENT_DETAIL_QUERY_KEY = 'participantDocumentDetail';
export const invalidateSignedDocumentQueries = (queryClient, { participantId, documentId }) => {
    void queryClient.invalidateQueries({ queryKey: [SITE_DOCUMENTS_QUERY_KEY] });
    void queryClient.invalidateQueries({ queryKey: [SITE_DOCUMENT_DETAIL_QUERY_KEY] });
    void queryClient.invalidateQueries({ queryKey: [SITE_DOCUMENT_INVITES_QUERY_KEY] });
    if (participantId) {
        void queryClient.invalidateQueries({ queryKey: [PARTICIPANT_DOCUMENTS_QUERY_KEY, participantId] });
    }
    if (documentId) {
        void queryClient.invalidateQueries({ queryKey: [PARTICIPANT_DOCUMENT_DETAIL_QUERY_KEY, documentId] });
        void queryClient.invalidateQueries({ queryKey: ['pts-final-document-url', documentId] });
    }
};
